import { getApi } from './apiBase';
import { deeplink_gate_entity } from './apiURL';

const fetchEntityBasic = (entityPath, entityId, { signal } = {}) =>
    getApi(deeplink_gate_entity(entityPath, entityId), {
        signal,
        _suppressErrorPopup: true
    });

export { fetchEntityBasic };
